import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');

@Injectable({
  providedIn: 'root'
})
export class OpinionreviewService {
  baseUrl: string = environment.serviceUrl;

  constructor(private httpClient: HttpClient) {
  }


  getReport(data): Observable<any> {
    return this.httpClient.post<any>(this.baseUrl + 'api/ReportApi/GetReport', data, { headers: header, observe: 'response' });
  }

}
